<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="#" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <h2>Corporate Innovation</h2>

        <p>We deeply believe in the power of world-changing <span class="versa">INNOVATION</span>. Especially the <span class="versa">CLEANTECH</span> sector has proven in
          recent years, that it is possible to change the world with innovation through its enormous success of
          improving <span class="versa">PHOTOVOLTAIK</span> and <span class="versa">WIND</span> power products while decreasing its costs massively.
          Therefore we try to live innovation every day, by constantly scrutinizing the current state of mind and
          continuously working on improving a given system. To make innovation become reality we apply proven methods
          and explore new paths to support the development of new processes, ideas or products. Thereby <span class="versa">START-UPS</span> can
          very well complement the innovation portfolio of <span class="versa">CORPORATIONS</span>.</p>
        <p> We provide the following services to boost your innovation capabilities and transform your business for a <span class="versa">GREEN</span> future:
        </p>

        <ul>
          <li>Strategic Foresight (Innovation Radar and Strategic Roadmapping)</li>
          <li>Innovation Exploration and corporate/ start-up matching</li>
          <li>Start-up scouting and evaluation</li>
          <li>Innovation Contests and Hackathons</li>
          <li>Intrapreneurship and Accelerator programs</li>
        </ul>
        <h2>Corporate project activity</h2>
        <ul class="years">
          <li><span>2015</span><a href="//www.rohrbeckheger.com/work/innovation-exploration/" target="_blank">Innovation Exploration</a> for a major corporate</li>
          <li><span>2015</span>IT tool based innovation radar for a major corporate in the energy and resource sector
          </li>
          <li><span>2014</span>Co-organization of a <a href="//www.laboratories.telekom.com/public/deutsch/newsroom/news/pages/t-labs-verleihen-sonderpreis-smart-energy-fuer-whats-my-carbon.aspx" target="_blank">Hackathon</a> with Berlin <a href="//www.geekettes.io/" target="_blank">Geekettes</a> for SAP</li>
          <li><span>2013</span>Development and organization of a innovation contest for a large corporate</li>
          <li><span>2012</span><a href="//papers.ssrn.com/sol3/papers.cfm?abstract_id=2197724" target="_blank">Smart Energy Working Group</a> workshop based development of new business models with 8
            utilities
          </li>
          <li><span>2011</span>Innovation Radar Energy for a major utility</li>
        </ul>
        <p class="end"></p>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default {
    methods: {
      back () {
        window.history.go(-1)
      }},
    data: function () {
      return {
        title: 'Corporate Innovation'
      }
    },
    // Usage with context the component
    head: {
      // To use "this" in the component, it is necessary to return the object through a function
      title: function () {
        return {
          inner: this.title
        }
      },
      meta: [
        { name: 'description', content: 'My description', id: 'desc' }
      ]
    }
  }
</script>



// WEBPACK FOOTER //
// Corporate.vue?208ad3e4